import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import PayButton from '../pay-button'
import { PaymentMethods } from '../pay-method/paymethods'
import { BlackMask } from '../../../../../../components/mask'
import ReactDOM from 'react-dom'
import CountDown from '../../../../../../components/count-down'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)

    const {
        showMethodList,
        setShowMethodList,
        onError,
        country,
        klarnas,
        orderTotal,
        payMethod,
        payMethods,
        selectPayMethodHandle,
        inputOrder,
        selectedCard,
    } = props

    const offsetTime = inputOrder.orderTime - inputOrder.serverTime

    const isHalf = offsetTime > 0 && !showMethodList

    return <div className={classes.Container}>
        <div className={`${classes.MethodContainer} ${showMethodList ? classes.Active : ''}`}>
            <PaymentMethods
                show={showMethodList}
                payMethods={payMethods}
                selectedPayMethod={payMethod?.id}
                orderTotal={orderTotal}
                onClose={() => setShowMethodList(false)}
                selectPayMethodHandle={selectPayMethodHandle}
                klarnas={klarnas}
                onError={onError}
                inputOrder={inputOrder}
                selectedCard={selectedCard}
            />

            {
                showMethodList && (typeof window !== 'undefined') && ReactDOM.createPortal(<BlackMask onClick={() => setShowMethodList(false)}/>, document.getElementById('root'))
            }
        </div>

        <div className={classes.PayContainer}>
            {
                isHalf && <div className={classes.CountDown}>
                    <span className={classes.Small}><FormattedMessage id="remaining_payment_time" defaultMessage="Remaining Payment Time"/>:</span><br/>
                    <span className={classes.Small}>
                        <CountDown offset={offsetTime} showDay showHour showLabel/>
                    </span>
                </div>
            }
            <div className={`${classes.PayButton} ${isHalf?classes.Half:''}`}>
                <PayButton
                    inputOrder={inputOrder}
                    onError={onError}
                    country={country}
                    klarnas={klarnas}
                    orderTotal={orderTotal}
                    payMethod={payMethod}
                    selectedCard={selectedCard}
                    redirectType="order"
                />
            </div>
        </div>

    </div>
}